import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private FireAuth: AngularFireAuth
  ) { }

   /* ************************************************************ */
  /* ***** Auth **** */
  /* ************************************************************ */
  // Login
  login(email: string, password: string) {
    return this.FireAuth.signInWithEmailAndPassword(email, password);
  }

  // Registro Usuario
  createUser(email: string, password: string) {
    return this.FireAuth.createUserWithEmailAndPassword(email, password);
  }

  // Logout
  async logout() {
    return await this.FireAuth.signOut();
  }

  // Get Uid State
  getUidState() {
    return this.FireAuth.authState;
  }

  // Get Uid
  async getUid() {
    const user = await this.FireAuth.currentUser;
    if (user) {
      return user.uid;
    }
  }

  // Is login
  async isLogin() {
    return await this.FireAuth.authState.pipe(first()).toPromise();
  }

  // Reset password
  async resetPassword(email: string) {
    return this.FireAuth.sendPasswordResetEmail(email);
  }

  /* ************************************************************ */


}
